import ResourceList from "../../features/CorporateResource/ResourceList";

const ViewResourcesPage = () => {
  return (
    <div>
      <ResourceList />
    </div>
  );
};
export default ViewResourcesPage;
